export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-vimeo-37e35f2c800d9dbae631bce0198fc3e0.svg";